import api from "../services/api";

// Create new flow
export const createFlow = async (flowData) => {
  return api.post("/api/flows", flowData);
};

// Update existing flow
export const updateFlow = async (flowId, flowData) => {
  return api.put(`/api/flows/${flowId}`, flowData);
};

// Get all flows for user
export const getFlows = async (params = {}) => {
  return api.get("/api/flows", { params });
};

// Get flows by phone ID
export const getFlowsByPhoneId = async (phoneId) => {
  return api.get(`/api/flows/flowByWaAccountId/${phoneId}`);
};

// Get flow by ID
export const getFlowById = async (flowId) => {
  return api.get(`/api/flows/${flowId}`);
};

// Delete flow
export const deleteFlow = async (flowId) => {
  return api.delete(`/api/flows/${flowId}`);
};

// Toggle flow active/inactive
export const toggleFlowStatus = async (flowId, isActive) => {
  return api.patch(`/api/flows/${flowId}/toggle`, { isActive });
};

// Generate flow using AI
export const generateFlowWithAI = async (description, flowName) => {
  return api.post("/api/flows/generate", { description, flowName });
};

// Conversational AI chat for flow building.
// options may include: includeAINodes, validationErrors, flowVariables,
// responseMode: 'auto' | 'plan' | 'flow' (plan = FLOW_PLAN_PREVIEW prompt only; flow = JSON generation appendix)
export const chatWithFlowAI = async (messages, currentFlow, options) => {
  return api.post("/api/flows/ai-chat", { messages, currentFlow, options });
};

// Allocate flow to a WhatsApp phone
export const allocateFlowToPhone = async (flowId, whatsappAccountId) => {
  return api.post(`/api/flows/${flowId}/allocate`, { whatsappAccountId });
};

// Deallocate flow from a WhatsApp phone
export const deallocateFlowFromPhone = async (flowId, whatsappAccountId) => {
  return api.post(`/api/flows/${flowId}/deallocate`, { whatsappAccountId });
};

// Get phones allocated to a flow (for test session reset)
export const getFlowAllocatedPhones = async (flowId) => {
  return api.get(`/api/flows/${flowId}/allocated-phones`);
};

// Reset runtime session for a customer phone across all flows and business lines
export const resetFlowSession = async (flowId, { customerPhone }) => {
  return api.post(`/api/flows/${flowId}/reset-session`, { customerPhone });
};
